import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { handleQuerySuccess } from '../../hooks/useQuriesSuccess';
import { apiRequest } from '../../Services/Common/ApiRequest';
import Global from '../../Services/Common/Global';
import { mapParamsBySchema } from '../../util';
import { MemberInfoModal_Schema } from './MemberInfoModal_Schema';

/**
 * 회원정보 모달 관련 React Query 훅 모음
 * - 회원정보 조회: useSearch1
 */

/**
 * useSearch1 - 회원정보 모달 조회
 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(MemberInfoModal_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['MemberInfoModal', 'getMemBasicR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Member.getMemBasicR1, params),
    enabled: false, // 수동 실행
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

